var map = {
	"./green-dots.svg": 387,
	"./green-horizontal-bars.svg": 388,
	"./green-points.svg": 389,
	"./green-solid.svg": 196,
	"./green-squares.svg": 390,
	"./purple-dots.svg": 391,
	"./purple-horizontal-bars.svg": 392,
	"./purple-points.svg": 393,
	"./purple-solid.svg": 195,
	"./purple-squares.svg": 394,
	"./purple-vertical-bars.svg": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1448;